import { ChangeDetectionStrategy, Component, EventEmitter, input, Input, Output } from '@angular/core';

import { Observable } from 'rxjs';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { Category } from '@fcom/dapi/api/models';
import { BreakdownModel } from '@fcom/dapi/interfaces';
import { asPaxTypeKey } from '@fcom/dapi/utils';
import { ModalButtons } from '@fcom/ui-components';

@Component({
  selector: 'fin-price-breakdown-per-passenger-modal',
  templateUrl: './price-breakdown-per-passenger.component.html',
  styleUrls: ['./price-breakdown-per-passenger.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PriceBreakdownPerPassengerComponent {
  public readonly ModalButtons = ModalButtons;
  public readonly asPaxTypeKey = asPaxTypeKey;
  public readonly SvgLibraryIcon = SvgLibraryIcon;
  public readonly Category = Category;

  readonly open = input(false);
  readonly title = input<string>();
  readonly showPoints = input(false);

  @Input()
  breakdowns$: Observable<BreakdownModel[]>;

  @Output()
  openChange = new EventEmitter<boolean>();
  @Output()
  closed = new EventEmitter<void>();

  readonly ENVIRONMENTAL_SURCHARGE = 'environmentalSurcharge';

  close(): void {
    this.openChange.emit(false);
    this.closed.emit();
  }
}
